module.exports = __webpack_public_path__ + "static/media/lastImage.01a6e952.png";